(function () {
  'use strict';

  var path = window.location.pathname.toLowerCase();
  var excluded =
    path === '/cart' ||
    path.indexOf('/checkout') === 0 ||
    path.indexOf('/account') === 0;

  if (excluded || window.Shopify?.designMode) return;

  var startedAt = Date.now();
  var teaserTimeReady = false;
  var autoOpenTimeReady = false;
  var scrollDepth = 0;
  var consentReady = false;
  var autoOpened = false;
  var hostObserver = null;
  var snoozeKey = 'khair_signup_snooze_until_v1';
  var pagesKey = 'khair_signup_pages_v1';
  var thirtyDays = 30 * 24 * 60 * 60 * 1000;
  var pageViews = 1;
  var teaser = null;
  var teaserTracked = false;
  var popupTracked = false;
  var commercePauseUntil = 0;

  function trackSignupEvent(name) {
    if (typeof window.clarity === 'function') {
      try {
        window.clarity('event', name);
      } catch (error) {
        // Signup behavior should never depend on analytics availability.
      }
    }
  }

  function safeRead(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeWrite(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // The experience still works when storage is unavailable.
    }
  }

  function isSnoozed() {
    var until = Number(safeRead(snoozeKey) || 0);
    return until > Date.now();
  }

  function trackPageView() {
    try {
      var pages = JSON.parse(window.sessionStorage.getItem(pagesKey) || '[]');
      var current = path || '/';
      if (pages.indexOf(current) === -1) pages.push(current);
      window.sessionStorage.setItem(pagesKey, JSON.stringify(pages.slice(-10)));
      return pages.length;
    } catch (error) {
      return 1;
    }
  }

  function formHost() {
    return document.querySelector('shopify-forms-embed');
  }

  function formHasContent(host) {
    return Boolean(
      host &&
        host.shadowRoot &&
        host.shadowRoot.querySelector('[data-testid="app-router"], [data-testid="form-teaser"]')
    );
  }

  function cookieBannerVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.getClientRects().length > 0;
  }

  function consentIsResolved() {
    if (cookieBannerVisible()) return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.shouldShowBanner === 'function') {
      try {
        return !privacy.shouldShowBanner();
      } catch (error) {
        return false;
      }
    }
    return Date.now() - startedAt >= 5000;
  }

  function ensureTeaser() {
    if (teaser) return teaser;
    teaser = document.createElement('button');
    teaser.type = 'button';
    teaser.className = 'khair-signup-teaser';
    teaser.textContent = 'GET 10% OFF';
    teaser.setAttribute('aria-label', 'Open the 10% off signup offer');
    teaser.addEventListener('click', function () {
      trackSignupEvent('signup_teaser_click');
      openForm(false);
    });
    document.body.appendChild(teaser);
    return teaser;
  }

  function showTeaser() {
    var host = formHost();
    if (!consentReady || !hasMeaningfulEngagement() || isSnoozed() || !formHasContent(host) || autoOpened) return;
    if (!teaserTracked) {
      teaserTracked = true;
      trackSignupEvent('signup_teaser_view');
    }
    ensureTeaser().classList.add('is-visible');
  }

  function hideTeaser() {
    if (teaser) teaser.classList.remove('is-visible');
  }

  function snoozeAfterDismissal() {
    safeWrite(snoozeKey, String(Date.now() + thirtyDays));
    autoOpened = true;
    hideTeaser();
    document.documentElement.classList.remove('khair-signup-form-visible');
  }

  function observeFormControls(host) {
    if (!host || !host.shadowRoot || host.dataset.khairSignupObserved === 'true') return;
    host.dataset.khairSignupObserved = 'true';
    host.shadowRoot.addEventListener(
      'click',
      function (event) {
        var pathItems = typeof event.composedPath === 'function' ? event.composedPath() : [];
        var closeControl = pathItems.find(function (item) {
          return item && item.getAttribute && item.getAttribute('aria-label') === 'Close modal';
        });
        var submitControl = pathItems.find(function (item) {
          return item && item.getAttribute && item.getAttribute('data-testid') === 'btn-form-submit';
        });
        if (submitControl) {
          autoOpened = true;
          hideTeaser();
        }
        if (closeControl) window.setTimeout(snoozeAfterDismissal, 250);
      },
      true
    );
  }

  function activateNativeForm(host) {
    if (!host || !host.shadowRoot) return;
    observeFormControls(host);
    var nativeTeaser = host.shadowRoot.querySelector('[data-testid="form-teaser"]');
    if (nativeTeaser) nativeTeaser.click();
  }

  function openForm(automatic) {
    var host = formHost();
    if (!formHasContent(host) || isSnoozed()) return;
    if (automatic) autoOpened = true;
    if (!popupTracked) {
      popupTracked = true;
      trackSignupEvent(automatic ? 'signup_popup_open_auto' : 'signup_popup_open_click');
    }
    hideTeaser();
    document.documentElement.classList.add('khair-signup-form-visible');
    window.requestAnimationFrame(function () {
      activateNativeForm(host);
    });
  }

  function updateScrollState() {
    var root = document.documentElement;
    var scrollable = Math.max(root.scrollHeight - window.innerHeight, 1);
    scrollDepth = Math.max(scrollDepth, window.scrollY / scrollable);
    evaluate();
  }

  function hasMeaningfulEngagement() {
    var firstPageEngagement = teaserTimeReady && scrollDepth >= 0.1;
    var laterPageEngagement = pageViews >= 2 && Date.now() - startedAt >= 10000;
    return firstPageEngagement || laterPageEngagement;
  }

  function hasStrongEngagement() {
    var firstPageEngagement = autoOpenTimeReady && scrollDepth >= 0.3;
    var laterPageEngagement = pageViews >= 2 && Date.now() - startedAt >= 15000;
    return firstPageEngagement || laterPageEngagement;
  }

  function evaluate() {
    consentReady = consentIsResolved();
    if (!consentReady || cookieBannerVisible()) {
      hideTeaser();
      document.documentElement.classList.remove('khair-signup-form-visible');
      return;
    }

    showTeaser();

    if (autoOpened || isSnoozed() || Date.now() < commercePauseUntil || !hasStrongEngagement()) return;
    openForm(true);
  }

  function watchForForm() {
    var host = formHost();
    if (host) {
      observeFormControls(host);
      if (hostObserver) hostObserver.disconnect();
      hostObserver = new MutationObserver(function () {
        observeFormControls(host);
        evaluate();
      });
      if (host.shadowRoot) hostObserver.observe(host.shadowRoot, { childList: true, subtree: true });
      evaluate();
      return true;
    }
    return false;
  }

  function initialise() {
    pageViews = trackPageView();
    ensureTeaser();
    updateScrollState();

    window.addEventListener('scroll', updateScrollState, { passive: true });
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.pp-variants, .pp-atc-btn, .pp-express-checkout, [name="add"]')) {
        commercePauseUntil = Date.now() + 15000;
      }
    }, true);
    document.addEventListener('submit', function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('pp-private-access-form')) {
        trackSignupEvent('signup_inline_submit');
      }
    }, true);
    document.addEventListener('visitorConsentCollected', function () {
      window.setTimeout(evaluate, 100);
    });

    var documentObserver = new MutationObserver(function () {
      if (watchForForm()) documentObserver.disconnect();
      evaluate();
    });
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    if (watchForForm()) documentObserver.disconnect();

    window.setTimeout(function () {
      teaserTimeReady = true;
      evaluate();
    }, 10000);

    window.setTimeout(function () {
      autoOpenTimeReady = true;
      evaluate();
    }, 28000);

    window.setInterval(evaluate, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
